/* eslint no-use-before-define: ["error", { "variables": false }] */

import PropTypes from 'prop-types';
import React from 'react';
import { StyleSheet, Text, View } from 'react-native-web';
import moment from 'moment';
import 'moment/locale/zh-cn';

import Color from './Color';

import { isSameDay } from './utils';

// Weekday names in Chinese
const weekdays = ['星期日', '星期一', '星期二', '星期三', '星期四', '星期五', '星期六'];

// Format date with year, month, day and weekday
const formatDateWithWeekday = (date) => {
  const m = moment(date);
  const weekday = weekdays[m.day()];
  return `${m.format('YYYY年MM月DD日')} ${weekday}`;
};

//gt: need to deal with locale later, for the purpose of rendering date/time
export default function Day({
  currentMessage = {
    createdAt: null
  },
  previousMessage = {},
  nextMessage = {},
  containerStyle = {},
  wrapperStyle = {},
  textStyle = {},
  inverted
}) {
  // When inverted, compare with previousMessage (earlier message in array)
  // When not inverted, compare with nextMessage (later message in array)
  const compareMessage = inverted ? previousMessage : nextMessage;

  // Only show date if current message has createdAt
  if (!currentMessage || !currentMessage.createdAt) {
    return null;
  }

  // Show date if compareMessage is empty/invalid, or if it's a different day
  // This ensures date is bound to the first message of a new day and stays stable
  if (!compareMessage || !compareMessage.createdAt || !isSameDay(currentMessage, compareMessage)) {
    return (
      <View style={[styles.container, containerStyle]}>
        <View style={wrapperStyle}>
          <Text style={[styles.text, textStyle]}>{formatDateWithWeekday(currentMessage.createdAt)}</Text>
        </View>
      </View>
    );
  }
  return null;
}

// Removed contextTypes - not used (getLocale is commented out)
// Day.contextTypes = {
//   getLocale: PropTypes.func
// };

const styles = StyleSheet.create({
  container: {
    alignItems: 'center',
    justifyContent: 'center',
    marginTop: 30,
    marginBottom: 30
  },
  text: {
    backgroundColor: Color.backgroundTransparent,
    color: Color.defaultColor,
    fontSize: 12,
    fontWeight: '600'
  }
});

// Removed defaultProps - using default parameters instead
// Day.defaultProps = {
//   currentMessage: {
//     createdAt: null
//   },
//   previousMessage: {},
//   nextMessage: {},
//   containerStyle: {},
//   wrapperStyle: {},
//   textStyle: {},
//   dateFormat: DATE_FORMAT
// };

Day.propTypes = {
  currentMessage: PropTypes.object,
  previousMessage: PropTypes.object,
  nextMessage: PropTypes.object,
  inverted: PropTypes.bool
  /*
  containerStyle: ViewPropTypes.style,
  wrapperStyle: ViewPropTypes.style,
  */
  //textStyle: Text.propTypes.style,
  //dateFormat: PropTypes.string
};
